import moment from 'moment';
import {BASE_URL} from "../../actions/types";



export function format(item) {
  if (item == null || isNaN(item)) return '--';
  else return parseFloat(item).toFixed(2);
}

export function formatPercent(item) {
  if (typeof item === 'string') {
    if (item.indexOf('%') !== -1) item = +item.replace('%', '').replace('+', '');
  }
  if (item == null || isNaN(item)) return '--';
  else return parseFloat(item).toFixed(2) + '%';
}

export function calcReturn(oldPrice, newPrice) {
  if (isNaN(oldPrice) || isNaN(newPrice) || oldPrice == null || newPrice == null) return '--';
  else return ((newPrice - oldPrice) / oldPrice) * 100;
}

export function formatDateYYYYMMDD(date) {
  if (!date) return null;

  return moment(date).format('YYYY-MM-DD');
}

export function numFormat(x) {
  if (isNaN(x)) return x;
  else return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export function fillStockWeight(stockWeight,tickerWeightGreen,tickerWeightRed) {
	if (isNaN(stockWeight)) return null;
	if (stockWeight > tickerWeightGreen) return 'positive-price'; else if (stockWeight < tickerWeightRed) return 'negative-price'; else return null;
}

export function fillMLPrice(BofAML12, price) {
	if (isNaN(BofAML12 || isNaN(price))) return null;
	if (BofAML12 < price) return 'red-fill'; else return null;
}

export function fillUpside(upside) {
	if (isNaN(upside)) return null;
	if (upside < 5) return 'red-fill'; else return null;
}

export function inputFill(res, price) {
	if (isNaN(res) || isNaN(price)) return null;
	if (res < price) return 'no-padding red-input-fill'; else return 'no-padding';
}

export function readOnlyFill(res, price) {
	if (isNaN(res) || isNaN(price)) return null;
	if (res < price) return 'red-fill'; else return null;
}

export function fillFiftyDayAvg(fiftyDayAvg, price) {
	if (isNaN(fiftyDayAvg || isNaN(price))) return null;
	if (fiftyDayAvg > price) return 'red-fill'; else return null;
}

export function earningDateColor(date) {
	if (date === 'N/A' || !date) return null;

	const currentDate = moment().startOf('day');
	const earningsDate = moment(date).startOf('day');
	const diff = earningsDate.diff(currentDate, 'days');

	if (diff === 0) {
		return 'earnings-today';
	}
	else if (diff === 1) {
		return 'earnings-1';
	}
	else if (diff === 2) {
		return 'earnings-2';
	}
}

export function priceColor(change) {
	if (isNaN(change)) return null;
	if (change >= 0) return 'positive-price'; else return 'negative-price';
}

export function circleColor(item) {
	if (item === 'undefined' || item === 'N/A' || !item) return 'circle circle-null';
	item = item.toLowerCase();
	if (item === 'buy') return 'circle circle-buy'; else if (item === 'hold' || item
		=== 'neutral') return 'circle circle-hold'; else return 'circle circle-sell';
}

export function fillMaxMin(value, obj, infoAr) {
	const ar = infoAr.map((item) => {
		return item[obj];
	});

	if (Math.max.apply(null, ar) === value) {
		return 'green-fill';
	}
	else if (Math.min.apply(null, ar) === value) {
		return 'red-fill';
	}
	else return null;
}

export function vsSNPFill(value) {
	if (isNaN(value)) return null;
	if (value > 3.5 || value < -3.5) return 'red-fill'; else return null;
}

export function stockReportLink({symbol, type}) {
	return `${BASE_URL()}/reports/${symbol}_${type}.pdf`;
}

export function calc(results) {
	// console.log("results",results);
	if (results.tickerInfo.length < 1) return results;
	const {tickerInfo, sectorInfo, quarterInfo, benchmarkInfo} = results;

	results.portfolio = {};

	/* convert all strings to numbers except for input values */

	const ignoreKeys = ['quarterly', 'adjCostbasis', 'adjCostbasisTotal', 'shares', 'SGqtr1', 'SGqtr2', 'SGqtr3',
		'SGqtr4', 'SPXqtr1', 'SPXqtr2', 'SPXqtr3', 'SPXqtr4', 'deck', 'resistance', 'support', 'quarter1', 'quarter2',
		'quarter3', 'notes',];

	Object.keys(results).forEach((key) => {
		for (let i = 0; i < results[key].length; i++) {
			Object.keys(results[key][i]).forEach((key2) => {
				if (!isNaN(results[key][i][key2])) {
					if (ignoreKeys.indexOf(key2) === -1) results[key][i][key2] = +results[key][i][key2];
				}
			});
		}
	});

	/* calculate percent change */

	for (let i = 0; i < tickerInfo.length; i++) {
		tickerInfo[i]['percentChange'] =
			((tickerInfo[i].price - tickerInfo[i].previousClose) / tickerInfo[i].previousClose) * 100;
	}

	for (let i = 0; i < sectorInfo.length; i++) {
		sectorInfo[i]['percentChange'] =
			((sectorInfo[i].price - sectorInfo[i].previousClose) / sectorInfo[i].previousClose) * 100;
		// console.log(sectorInfo[i]['percentChange']);
	}

	/* calculate upside */

	for (let i = 0; i < tickerInfo.length; i++) {
		tickerInfo[i]['upside'] = (tickerInfo[i].BofAML12 / tickerInfo[i].price - 1) * 100;
	}

	/* calulate ticker weights */

	let portfolioTotal = 0;

	for (let i = 0; i < tickerInfo.length; i++) {
		const stockValue = tickerInfo[i].price * +tickerInfo[i].shares;
		tickerInfo[i]['stockValue'] = stockValue;
		portfolioTotal += stockValue;
	}

	// results.portfolio['portfolioTotal'] = portfolioTotal;
	// console.log("portfolioTotal", portfolioTotal);
	for (let i = 0; i < tickerInfo.length; i++) {
		tickerInfo[i]['stockWeight'] = (tickerInfo[i].stockValue / portfolioTotal) * 100;
	}

	/* calculate sector weights */

	for (let i = 0; i < sectorInfo.length; i++) {
		let totalSectorWeight = 0;

		const tickersInSector = tickerInfo.filter((item) => {
			return item.sectorSymbol === sectorInfo[i].symbol;
		});

		for (let i = 0; i < tickersInSector.length; i++) {
			totalSectorWeight += +tickersInSector[i].stockWeight;
		}
		sectorInfo[i]['scmSectorWeight'] = totalSectorWeight;
		sectorInfo[i]['vsSNP'] = totalSectorWeight - sectorInfo[i].sectorWeight;
	}

	/* calculate SCM sector */
	// calculate G/L
	for (let i = 0; i < tickerInfo.length; i++) {
		tickerInfo[i]['gainLoss'] = tickerInfo[i].price - tickerInfo[i].previousClose;

		// console.log('-> ', tickerInfo[i]['gainLoss']);
		tickerInfo[i]['gainLossShares'] = tickerInfo[i].gainLoss * +tickerInfo[i].shares;
	}

	// calculate total G/L per sector
	for (let i = 0; i < sectorInfo.length; i++) {
		let totalGainLossShares = 0;

		const tickersInSector = tickerInfo.filter((item) => {
			return item.sectorSymbol === sectorInfo[i].symbol;
		});

		for (let i = 0; i < tickersInSector.length; i++) {
			totalGainLossShares += tickersInSector[i].gainLossShares;
		}
		sectorInfo[i]['totalGainLossShares'] = totalGainLossShares;
	}

	// calculate totalPreviousClose
	for (let i = 0; i < tickerInfo.length; i++) {
		tickerInfo[i]['totalPreviousClose'] = tickerInfo[i].previousClose * +tickerInfo[i].shares;
	}

	// calculate SCM sector vaule
	for (let i = 0; i < sectorInfo.length; i++) {
		let sectorTotalPreviousClose = 0;

		const tickersInSector = tickerInfo.filter((item) => {
			return item.sectorSymbol === sectorInfo[i].symbol;
		});

		if (tickersInSector.length > 0) {
			for (let i = 0; i < tickersInSector.length; i++) {
				sectorTotalPreviousClose += tickersInSector[i].totalPreviousClose;
			}

			sectorInfo[i]['scmSector'] = (sectorInfo[i].totalGainLossShares / sectorTotalPreviousClose) * 100;
		}
		else {
			sectorInfo[i]['scmSector'] = 0.0;
		}
	}

	/* calculate ETF today % */

	for (let i = 0; i < sectorInfo.length; i++) {
		sectorInfo[i]['etfTodayPercent'] =
			((sectorInfo[i].price - sectorInfo[i].previousClose) / sectorInfo[i].previousClose) * 100;
	}

	/* calculate LAG/LEAD */

	for (let i = 0; i < sectorInfo.length; i++) {
		const effect = sectorInfo[i].etfTodayPercent * sectorInfo[i].sectorWeight;
		const sectorEffect = sectorInfo[i].scmSector * sectorInfo[i].scmSectorWeight;
		sectorInfo[i]['lagLead'] = sectorEffect - effect;
	}

	/* ALPHA PERF */

	for (let i = 0; i < tickerInfo.length; i++) {
		tickerInfo[i]['quarterlyTotal'] =
			+tickerInfo[i].quarterly * +tickerInfo[i].shares + +tickerInfo[i].adjCostbasis;
		tickerInfo[i]['todayTotal'] = tickerInfo[i].price * +tickerInfo[i].shares;
		tickerInfo[i]['alphaPerf'] =
			((tickerInfo[i].todayTotal - tickerInfo[i].quarterlyTotal) / tickerInfo[i].quarterlyTotal) * 100;
	}

	/* SG PERF */

	for (let i = 0; i < sectorInfo.length; i++) {
		let quarterlyCostBasisTotal = 0, todayCostBasisTotal = 0;

		const tickersInSector = tickerInfo.filter((item) => {
			return item.sectorSymbol === sectorInfo[i].symbol;
		});

		for (let i = 0; i < tickersInSector.length; i++) {
			quarterlyCostBasisTotal += tickersInSector[i].quarterlyTotal;
			todayCostBasisTotal += tickersInSector[i].todayTotal;
		}

		sectorInfo[i]['quarterlyCostBasis'] = quarterlyCostBasisTotal + +sectorInfo[i].adjCostbasisTotal;
		sectorInfo[i]['todayCostBasis'] = todayCostBasisTotal;

		if (tickersInSector.length > 0) {
			sectorInfo[i]['sgPerf'] =
				((sectorInfo[i].todayCostBasis - sectorInfo[i].quarterlyCostBasis) / sectorInfo[i].quarterlyCostBasis)
				* 100;
		}
		else {
			sectorInfo[i]['sgPerf'] = 0.0;
		}
	}

	/* ETF PERF */

	for (let i = 0; i < sectorInfo.length; i++) {
		if (+sectorInfo[i].quarterly === 0) {
			sectorInfo[i]['etfPerf'] = 0;
		}
		else {
			sectorInfo[i]['etfPerf'] =
				((sectorInfo[i].price - +sectorInfo[i].quarterly) / +sectorInfo[i].quarterly) * 100;
		}
	}

	/* QTR LAG/LEAD */

	for (let i = 0; i < sectorInfo.length; i++) {
		sectorInfo[i]['quarterSCM'] = sectorInfo[i].sgPerf * sectorInfo[i].scmSectorWeight;
		sectorInfo[i]['quarterEffect'] = sectorInfo[i].sectorWeight * sectorInfo[i].etfPerf;
		sectorInfo[i]['quarterLagLead'] = sectorInfo[i].quarterSCM - sectorInfo[i].quarterEffect;
	}

	/* YTD TOTAL */

	for (let i = 0; i < sectorInfo.length; i++) {
		sectorInfo[i]['ytdTotal'] =
			+sectorInfo[i].quarter1 + +sectorInfo[i].quarter2 + +sectorInfo[i].quarter3 + sectorInfo[i].quarterLagLead;
	}

	/* WHY */

	for (let i = 0; i < sectorInfo.length; i++) {
		const {quarterLagLead, sgPerf, etfPerf, scmSectorWeight, sectorWeight} = sectorInfo[i];

		let reason = '';
		if (quarterLagLead > 0 && sgPerf > etfPerf && scmSectorWeight > sectorWeight) {
			reason = 'BOTH';
		}
		else if (quarterLagLead > 0 && sgPerf > etfPerf && +scmSectorWeight < sectorWeight) {
			reason = 'ALPHA';
		}
		else if (quarterLagLead > 0 && sgPerf > etfPerf) {
			reason = 'WT';
		}

		sectorInfo[i]['why'] = reason;
	}

	/* DASHBOARD SUMMARY */

	let qtrCostBasisTotal = 0, todayCostBasisTotal = 0;

	for (let i = 0; i < sectorInfo.length; i++) {
		qtrCostBasisTotal += sectorInfo[i].quarterlyCostBasis;
		todayCostBasisTotal += sectorInfo[i].todayCostBasis;
	}

	const SPXQtr = benchmarkInfo.filter((item) => item.symbol === '^GSPC')[0];
	const currentQuarter = quarterInfo.currentQuarter;

	// Split the formula and placed it in conditions so that 0 is not divided by zero. (which caused a NaN)
	let quarterInfoValue;
	if (todayCostBasisTotal !== 0 && qtrCostBasisTotal !== 0) {
		quarterInfoValue = +(((todayCostBasisTotal - qtrCostBasisTotal) / qtrCostBasisTotal) * 100).toFixed(2);
	}
	else {
		quarterInfoValue = 0;
	}
	quarterInfo[`SGqtr${currentQuarter}`] = quarterInfoValue;
	// quarterInfo[`SPXqtr${currentQuarter}`] = +((((Number(SPXQtr.price.replace(/,/g, '')) - +SPXQtr.quarterly) / +SPXQtr.quarterly) * 100).toFixed(2));

	// console.log(SPXQtr)

	if (SPXQtr && SPXQtr.price && SPXQtr.price.toString().includes(',')) {
		quarterInfo[`SPXqtr${currentQuarter}`] =
			+(((Number(SPXQtr.price.replace(/,/g, '')) - +SPXQtr.quarterly) / +SPXQtr.quarterly) * 100).toFixed(2);
	}
	else {
		if(SPXQtr.price && SPXQtr.quarterly) {
			quarterInfo[`SPXqtr${currentQuarter}`] =
				+(((Number(SPXQtr.price) - +SPXQtr.quarterly) / +SPXQtr.quarterly) * 100).toFixed(2);
		}
		else {
			quarterInfo[`SPXqtr${currentQuarter}`]=0
		}

	}

	quarterInfo['qtr1Diff'] = +quarterInfo.SGqtr1 - +quarterInfo.SPXqtr1;
	quarterInfo['qtr2Diff'] = +quarterInfo.SGqtr2 - +quarterInfo.SPXqtr2;
	quarterInfo['qtr3Diff'] = +quarterInfo.SGqtr3 - +quarterInfo.SPXqtr3;
	quarterInfo['qtr4Diff'] = +quarterInfo.SGqtr4 - +quarterInfo.SPXqtr4;

	const {SGqtr1, SGqtr2, SGqtr3, SGqtr4} = quarterInfo;
	quarterInfo['SGTotal'] =
		((1 + +SGqtr1 / 100) * (1 + +SGqtr2 / 100) * (1 + +SGqtr3 / 100) * (1 + +SGqtr4 / 100) - 1) * 100;

	const {SPXqtr1, SPXqtr2, SPXqtr3, SPXqtr4} = quarterInfo;
	quarterInfo['SPXTotal'] =
		((1 + +SPXqtr1 / 100) * (1 + +SPXqtr2 / 100) * (1 + +SPXqtr3 / 100) * (1 + +SPXqtr4 / 100) - 1) * 100;

	quarterInfo['totalDiff'] = quarterInfo.SGTotal - quarterInfo.SPXTotal;

	/* BENCHMARK SUMMARY */

	let totalGainLoss = 0;
	for (let i = 0; i < tickerInfo.length; i++) {
		totalGainLoss += tickerInfo[i].gainLossShares;
	}
	quarterInfo['SCMSummary'] = (totalGainLoss / (todayCostBasisTotal - totalGainLoss)) * 100;
	results.portfolio['portfolioGainLoss'] = totalGainLoss;
	// done
	return results;
}

export function calcWeightedAvgs(results) {
	const {tickerInfo, } = results;
	// console.log(sectionsIds,"customizations")

	let marketCapCount = 0, marketCapAvg = 0, marketCapTotal = 0;
	let PERatioCount = 0, PERatioAvg = 0, PERatioTotal = 0;
	let EPSCount = 0, EPSAvg = 0, EPSTotal = 0;
	let betaCount = 0, betaAvg = 0, betaTotal = 0;
	let dividendCount = 0, dividendAvg = 0, dividendTotal = 0;
	let dividendPcntCount = 0, dividendPcntAvg = 0, dividendPcntTotal = 0;
	let sectionsData=[0,0,0,0,0,0,0,0,0,0,0]
	for (let i = 0; i < tickerInfo.length; i++) {
		const {marketCap, PERatio, EPS, beta, dividend, dividendPercent, sector_id} = tickerInfo[i];
		if(!isNaN(sector_id)){sectionsData[sector_id-1]++}
		if (!isNaN(marketCap)) {
			marketCapTotal += +marketCap;
			// marketCapCount += 1;
		}

		if (!isNaN(PERatio)) {
			PERatioTotal += +PERatio;
			// PERatioCount += 1;
		}

		if (!isNaN(EPS)) {
			EPSTotal += +EPS;
			// EPSCount += 1;
		}

		if (!isNaN(beta)) {
			betaTotal += +beta;
			// betaCount += 1;
		}

		if (!isNaN(dividend) && !isNaN(dividendPercent) && dividend > 0 && dividendPercent > 0) {
			dividendTotal += +dividend;
			dividendPcntTotal += +dividendPercent;
			// dividendCount += 1;
			// dividendPcntCount += 1;
		}
	}

	const tickerCount = tickerInfo.length;

	marketCapAvg = numFormat(format(marketCapTotal / tickerCount));
	PERatioAvg = format(PERatioTotal / tickerCount);
	betaAvg = format(betaTotal / tickerCount);
	EPSAvg = format(EPSTotal / tickerCount);
	dividendAvg = format(dividendTotal / tickerCount);
	dividendPcntAvg = formatPercent(dividendPcntTotal / tickerCount);

	return {
		marketCapAvg, PERatioAvg, betaAvg, EPSAvg, dividendAvg: `${dividendAvg} (${dividendPcntAvg})`,sectionsData
	};
}
